import React from "react";

const ContactsCard = ({ manager }) => {
  return (
    <div className="contacts-card">
      <h2 className="contacts-card-subtitle">{manager.title}</h2>
      <div className="contacts-card-info">
        {manager.contacts?.map((contact) => (
          <div key={contact.id}>
            <div className="contacts-card-top-part">
              <div className="contacts-card__info-img">
                <img loading="lazy" src={contact.image} alt={contact.alt || contact.name} />
              </div>
              <div className="contacts-card__info-descr">
                <p className="contacts-card__info-descr-name">{contact.name}</p>
                <p className="contacts-card__info-descr-post">
                  {contact.position}
                </p>
              </div>
            </div>
            <div className="contacts-card-border"></div>
            <div className="contacts-card__info-connect">
              {contact.email && <p>Email.:&nbsp; {contact.email}</p>}
              {contact.phone && <p>Тел.:&nbsp; {contact.phone}</p>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ContactsCard;
